export enum TicketType {
    sport = 'sport',
    lotto = 'lotto',
    luckySix = 'LuckySix',
    greyhound = 'GreyhoundRaces',
}

export enum TicketStatus {
    active = 'active',
    canceled = 'canceled',
    lost = 'lost',
    obsolete = 'obsolete',
    payed = 'payed',
    refund = 'refund',
    win = 'win',
}

export enum EventType {
    static = 'static',
    live = 'live',
}

export enum EventStatus {
    active = 'active',
    lost = 'lost',
    win = 'win',
    refund = 'refund'
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--12!./src/core/models/tickets/enums.ts